<template>
	<div id="user-panel" class="container panel">
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>
			<div class="col-md-9 content">
				<dash-head class="mb-3" title="User Account" subtitle="Password Security Portal" :username="name" :sitename="sitename"></dash-head>		

				<div class="hr-divider mt-2 mb-3">
					<h3 class="hr-divider-content hr-divider-heading"><!--Domain Details--></h3>
				</div>

				<div v-if="!showChangePasswordForm">
					<div class="row mt-3">
						<div class="col-md-6">
							<dl>
									<dt>Email</dt>
									<dd>{{email}}</dd>

									<dt>Name</dt>
									<dd>{{name}}</dd>
							</dl>
						</div>
						<div class="col-md-6">
							<dl>
									<dt>Permissions</dt>
									<dd>{{permissionText}}</dd>

									<dt>Show Passwords</dt>
									<dd>{{showPasswords}}</dd>
							</dl>
						</div>
					</div>	


					<div class="row mt-3 mb-3">
						<div class="col-md-6">
							<button v-if="impersonating" class="btn btn-outline-primary px-3" @click.prevent="switchBack">Switch Back</button>
						</div>
						<div class="col-md-6 text-right">
							<button v-if="false" class="btn btn-outline-primary px-3" @click.prevent="editUser">Edit User</button>
							<button class="btn btn-outline-primary px-3" type="button" @click="showChangePassword(true)">Change Password</button>
						</div>
					</div>
				</div>

				<change-password-form v-if="showChangePasswordForm" class="mt-3" @close-change-password="showChangePassword(false)"></change-password-form>

			</div>
		</div>
	</div>
</template>

<script>
import SideBar from './SideBar'
import DashHead from './DashHead'
import ChangePasswordForm from './ChangePasswordForm'

import router from '../router'
import store from '../state'

export default {
	name: 'UserPanel',
	components: {SideBar,DashHead,ChangePasswordForm},
	data () {
		return {		
			password: '',
			confirm: '',
			hasError: false,
			showChangePasswordForm: false
		}
	},
	methods: {
		showChangePassword(value) {
			this.showChangePasswordForm = value;
		},
		editUser() {

		},
		async switchBack() {
			//Ensure the user details are loaded
			store.commit('unswitch');
			await store.dispatch('getUserAsync');

			store.dispatch('getDomainsAsync');
			store.dispatch('getEmailsAsync');
			store.dispatch('getAuditsAsync');
			store.dispatch('getSourcesAsync');

			//Return to users page where the switch happened
			router.push({name: 'users'});  
		}
	},
	computed: {
		email() {
			return store.state.user.email;
		},
		name() {
			return store.state.user.firstName + store.state.user.lastName;
		},
		sitename() {
			return store.state.user.siteName;
		},
		permissions() {
			if (store.state.user && store.state.user.roles) return store.state.user.roles;
			return [];
		},
		permissionText() {
			if (store.state.user && store.state.user.roles) return store.state.user.roles.join(' ');
			return '';
		}, 
		showPasswords() {
			return store.state.user.showPasswords;
		},
		impersonating() {
			return store.state.originalJwt != null;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/UserPanel.vue